import { CountryLabel, SelectedCountry } from "../types/common";

export const passportFieldsEnabled = (
  ukVisaReasonSelected?: boolean,
  country?: SelectedCountry
) =>
  ukVisaReasonSelected ||
  country?.label === CountryLabel.Morocco ||
  country?.label === CountryLabel.Myanmar ||
  country?.label === CountryLabel.HongKong;
